import { useEffect, useState } from "react";

export function useClock(): Date {
  const [clock, setClock] = useState(() => new Date());

  useEffect(() => {
    const t = window.setInterval(() => setClock(new Date()), 30 * 1000);
    return () => window.clearInterval(t);
  }, []);

  return clock;
}
